import React from 'react';
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-16">
      <Helmet>
        <title>Rasoha Academy | About Us - Our Story & Mission</title>
        <meta name="description" content="Learn about Rasoha Academy's mission, vision, and commitment to excellence in education. Discover our story and values that shape our educational approach." />
        <meta name="keywords" content="Rasoha Academy About, School Mission, Educational Vision, Narok School, Academic Excellence, Student Development" />
        <meta property="og:title" content="Rasoha Academy | About Us - Our Story & Mission" />
        <meta property="og:description" content="Learn about Rasoha Academy's mission, vision, and commitment to excellence in education." />
        <meta property="og:url" content="https://rasohaacademy.com/about" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            About Rasoha School
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Learn about our mission, values, and commitment to educational excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
              Our Mission
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              At Rasoha School, we are committed to providing a comprehensive education 
              that nurtures intellectual curiosity, fosters creativity, and develops 
              strong character in our students.
            </p>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Our dedicated faculty and staff work together to create an environment 
              where every student can thrive academically, socially, and emotionally.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">500+</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">Students</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">50+</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">Faculty</div>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Our Values
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-blue-600 dark:text-blue-400 text-sm">✓</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white">Excellence</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    Striving for the highest standards in everything we do.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-green-600 dark:text-green-400 text-sm">✓</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white">Integrity</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    Building trust through honest and ethical behavior.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-purple-600 dark:text-purple-400 text-sm">✓</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white">Innovation</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    Embracing new ideas and creative solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 